/* import __COLOCATED_TEMPLATE__ from './insertion-view.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();